import { useEffect, useState } from 'react'
import { Box, Typography, Paper, List, ListItem, ListItemText, Chip } from '@mui/material'
import { adminApi, tracksApi, waypointsApi, syncApi } from '../lib/sdkClient'

type Check = { name: string; ok: boolean; detail?: string }

export default function DevPage() {
  const [checks, setChecks] = useState<Check[]>([])

  useEffect(() => {
    let canceled = false
    ;(async () => {
      const results: Check[] = []

      async function run(name: string, fn: () => Promise<any>) {
        try {
          const res = await fn()
          results.push({ name, ok: true, detail: (res && res.status) ? String(res.status) : 'ok' })
        } catch (e: any) {
          results.push({ name, ok: false, detail: e?.message || String(e) })
        }
      }

      await run('Admin: Overview', () => adminApi.adminOverviewStatsArtrackAdminStatsOverviewGet())
      await run('Admin: Activity Feed', () => adminApi.adminActivityFeedArtrackAdminActivityFeedGet(5))
      await run('Admin: Tracks', () => adminApi.adminTracksArtrackAdminTracksGet(undefined, undefined, 5, 0))
      await run('Admin: Moderation Queue', () => adminApi.adminModerationQueueArtrackAdminWaypointsModerationGet('pending', 5, 0))
      await run('Admin: System Health', () => adminApi.adminSystemHealthArtrackAdminSystemHealthGet())
      await run('Admin: Analytics Usage', () => adminApi.adminAnalyticsUsageArtrackAdminAnalyticsUsageGet('7d'))
      await run('Admin: Analytics Performance', () => adminApi.adminAnalyticsPerformanceArtrackAdminAnalyticsPerformanceGet())
      await run('Admin: Logs', () => adminApi.adminLogsErrorsArtrackAdminLogsErrorsGet(5))

      await run('Tracks: List', () => tracksApi.listTracksArtrackTracksGet(undefined, 5, 0))
      await run('Waypoints: List', () => waypointsApi.listWaypointsArtrackWaypointsGet(undefined, 5, 0))
      await run('Sync: Status', () => syncApi.getSyncStatusArtrackSyncStatusGet())
      await run('GPS: Health', () => syncApi.healthCheckArtrackSyncHealthGet())

      if (!canceled) setChecks(results)
    })()
    return () => { canceled = true }
  }, [])

  return (
    <Box>
      <Typography variant="h4" sx={{ mb: 2 }}>Developer API Smoke Test</Typography>
      <Paper>
        <List>
          {checks.map((c, idx) => (
            <ListItem key={idx} divider>
              <ListItemText primary={c.name} secondary={c.detail} />
              <Chip label={c.ok ? 'OK' : 'FAIL'} color={c.ok ? 'success' : 'error'} size="small" />
            </ListItem>
          ))}
        </List>
      </Paper>
    </Box>
  )
}

